import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { AddVenueSkeleton } from '@components/add-venue-skeleton/add-venue-skeleton';
import { InfoSkeleton } from '@components/info-skeleton/info-skeleton';
import { IntegrationsSkeleton } from '@components/integrations-skeleton/integrations-skeleton';
import { PresetsHomeSkeleton } from '@components/presets/presets-home-skeleton/presets-home-skeleton';
import { ReportPageSkeleton } from '@components/report-skeleton/report-skeleton';
import { UsersSkeleton } from '@components/users-skeleton/users-skeleton';

import { GenericContentSkeleton } from './generic-content-skeleton';

const getSkeletonContent = (pathname: string): ReactNode => {
  if (pathname.endsWith('/report')) return <ReportPageSkeleton />;
  if (pathname.endsWith('/add-venue')) return <AddVenueSkeleton />;
  if (/\/company\/users(\/|$)/.test(pathname)) return <UsersSkeleton />;
  if (pathname.endsWith('/company/info')) return <InfoSkeleton />;
  if (pathname.endsWith('/company/integrations') || pathname.endsWith('/company/widget'))
    return <IntegrationsSkeleton />;
  if (/\/offers(\/|$)/.test(pathname)) return <PresetsHomeSkeleton />;
  return <GenericContentSkeleton />;
};

export const RouteContentSkeleton = () => {
  const { pathname } = useLocation();
  return <>{getSkeletonContent(pathname)}</>;
};
